import makeStyles from '@mui/styles/makeStyles';

const useUserListingStyles = makeStyles({
  root: {},
  Rowstyle: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  tdStyle: {
    border: '1px solid #dddddd',
    padding: '8px',
    textAlign: 'center',
  },
  thStyle: {
    backgroundColor: '#f2f2f2',
    padding: '8px',
    textAlign: 'center',
  }, tableStyle: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
  }, iconStyle: {
    height: '20px',
    width: '20px',
    margin: '5px'
  }
});

export default useUserListingStyles;
